import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import Landing from "../src/components/landing/landing";
import Services from "../src/components/services/services";
import AllServices from "../src/components/allservices/allservices";
import Gallery from "../src/components/gallery/gallery";
import AfterCare from "../src/components/aftercare/aftercare";
import ContactUs from "../src/components/contactus/contactus";
import Header from "../src/components/header/header";
import FAQ from "../src/components/FAQ/faq";
import NotFoundPage from "../src/components/errorpage/errorpage";
import SuccessPage from "./components/SuccessPage/successPage";
import AdminLogin from "./components/admin/AdminLogin";
import AdminDashboard from "./components/admin/AdminDashboard";
import BlogPage from "./components/blog/blog";
import BlogDetailPage from "./components/blog/blogdetail"; // ✅ import the new component
import EarlobePiercing from "./components/allservices/earlobepiercing"; // ✅ import the new component
import BabyPiercing from "./components/allservices/babypiercing";
import SecondLobePiercing from "./components/allservices/secondlobepiercing";
import HighLobePiercing from "./components/allservices/highlobepiercing";
import UpperLobePiercing from "./components/allservices/upperlobepiercing";
import StackLobePiercing from "./components/allservices/stacklobepiercing";
import NosePiercing from "./components/allservices/nosepiercing";
import DoubleNosePiercing from "./components/allservices/doublenosepiercing";
import TonguePiercing from "./components/allservices/tonguepiercing";
import HelixPiercing from "./components/allservices/helixpiercing";
import TragusPiercing from "./components/allservices/traguspiercing";
import RookPiercing from "./components/allservices/rookpiercing";
import IndustrialPiercing from "./components/allservices/industrialpiercing";
import DoubleTragusPiercing from "./components/allservices/doubletraguspiercing";
import BugadiPiercing from "./components/allservices/bugadipiercing";
import SeptumPiercing from "./components/allservices/septumpiercing";
import SmiliePiercing from "./components/allservices/smileypiercing";
import EyebrowPiercing from "./components/allservices/eyebrowpiercing";
import TripleHelixPiercing from "./components/allservices/triplehelixpiercing";
import DoubleHelixPiercing from "./components/allservices/doublehelixpiercing";
import MidHelixPiercing from "./components/allservices/midhelixpiercing";
import TripleForwardHelixPiercing from "./components/allservices/tripleforwardhilexpiercing";
import DoubleForwardHelixPiercing from "./components/allservices/doubleforwardhilexpiercing";
import ForwardHelixPiercing from "./components/allservices/forwardhelixpiercing";
import FlatPiercing from "./components/allservices/flatpiercing";
import FauxRookPiercing from "./components/allservices/fauxrookpiercing";
import HiddenHelixPiercing from "./components/allservices/hiddenhelixpiercing";
import BellyPiercing from "./components/allservices/bellypiercing";
import DoubleFlatPiercing from "./components/allservices/doubleflatpiercing";
import TripleFlatPiercing from "./components/allservices/tripleflatpiercing";
import DaithPiercing from "./components/allservices/daithpiercing";
import SnakeBiteMidiPiercing from "./components/allservices/snakebitemidipiercing";
import ConchPiercing from "./components/allservices/conchpiercing";
import ContraConchPiercing from "./components/allservices/contraconchpiercing";
import OrbitalPiercing from "./components/allservices/orbitalpiercing";
import SnugPiercing from "./components/allservices/snugpiercing";
import SurfaceTragusPiercing from "./components/allservices/surfacetraguspiercing";
import AntiTragusPiercing from "./components/allservices/antitraguspiercing";
import LipPiercing from "./components/allservices/lippiercing";
import LipSnakeBitePiercing from "./components/allservices/lipsnakebitepiercing";
import AshleyPiercing from "./components/allservices/ashieylippiercing";
import MedusaLipPiercing from "./components/allservices/medusalippiercing";
import MonroeLipPiercing from "./components/allservices/monroelippiercing";
import VerticalLabretLipPiercing from "./components/allservices/verticallabretlippiercing";
import CheekDimplePiercing from "./components/allservices/cheekdimplepiercing";
import NipplePiercing from "./components/allservices/nipplepiercing";
import IntimatePiercing from "./components/allservices/intimatepiercing";
import ChestDermalPiercing from "./components/allservices/chestdermalpiercing";
import ChestSurfacePiercing from "./components/allservices/chestsurfacepiercing";
import FingerDermalPiercing from "./components/allservices/fingerdermalpiercing";
import FaceDermalPiercing from "./components/allservices/facedermalpiercing";
import HandWristDermalPiercing from "./components/allservices/handwristdermalpiercing";
import BackDimpleDermalPiercing from "./components/allservices/backdimpledermalpiercing";
import NapePiercing from "./components/allservices/napepiercing";
import CollarBonePiercing from "./components/allservices/collarbonepiercing";
import MicroDermalPiercing from "./components/allservices/microdermalpiercing";
import SnakeEyeTonguePiercing from "./components/allservices/snakeeyetonguepiercing";
import TongueWebPiercing from "./components/allservices/tonguewebpiercing";


const AppContent = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  // ✅ Hide Header only for these admin routes
  const hideHeaderRoutes = ["/admin", "/admin/dashboard"];

  return (
    <div className="p-0 xhidden">
      {/* ✅ Show Header on all except admin pages */}
      {!hideHeaderRoutes.includes(location.pathname) && <Header />}

      <Routes>
        {/* Home Page */}
        <Route
          path="/"
          element={
            <>
              <Landing />
              <Services />
              <Gallery />
              <AfterCare />
              <BlogPage />
              <FAQ />
              <ContactUs />
            </>
          }
        />

        {/* ✅ Blog Detail Page Route */}
        <Route path="/blog/:urlKey" element={<BlogDetailPage />} />

        {/* Other Pages */}
        <Route path="/allservices" element={<AllServices />} />
        <Route path="/earlobepiercing" element={<EarlobePiercing />} />
        <Route path="/babypiercing" element={<BabyPiercing />} />
        <Route path="/secondlobepiercing" element={<SecondLobePiercing />} />
        <Route path="/highlobepiercing" element={<HighLobePiercing />} />
        <Route path="/upperlobepiercing" element={<UpperLobePiercing />} />
        <Route path="/stacklobepiercing" element={<StackLobePiercing />} />
        <Route path="/nosepiercing" element={<NosePiercing />} />
        <Route path="/doublenosepiercing" element={<DoubleNosePiercing />} />
        <Route path="/bellypiercing" element={<BellyPiercing />} />
        <Route path="/tonguepiercing" element={<TonguePiercing />} />
        <Route path="/septumpiercing" element={<SeptumPiercing />} />
        <Route path="/smiliepiercing" element={<SmiliePiercing />} />
        <Route path="/eyebrowpiercing" element={<EyebrowPiercing />} />
        <Route path="/traguspiercing" element={<TragusPiercing />} />
        <Route path="/doubletraguspiercing" element={<DoubleTragusPiercing />} />
        <Route path="/industrialpiercing" element={<IndustrialPiercing />} />
        <Route path="/bugadipiercing" element={<BugadiPiercing />} />
        <Route path="/helixpiercing" element={<HelixPiercing />} />
        <Route path="/doublehelixpiercing" element={<DoubleHelixPiercing />} />
        <Route path="/midhelixpiercing" element={<MidHelixPiercing />} />
        <Route path="/triplehelixpiercing" element={<TripleHelixPiercing />} />
        <Route path="/hiddenhelixpiercing" element={<HiddenHelixPiercing />} />
        <Route path="/forwardhelixpiercing" element={<ForwardHelixPiercing />} />
        <Route path="/doubleforwardhelixpiercing" element={<DoubleForwardHelixPiercing />} />
        <Route path="/tripleforwardhelixpiercing" element={<TripleForwardHelixPiercing />} />
        <Route path="/rookpiercing" element={<RookPiercing />} />
        <Route path="/fauxrookpiercing" element={<FauxRookPiercing />} />
        <Route path="/flatpiercing" element={<FlatPiercing />} />
        <Route path="/doubleflatpiercing" element={<DoubleFlatPiercing />} />
        <Route path="/tripleflatpiercing" element={<TripleFlatPiercing />} />
        <Route path="/daithpiercing" element={<DaithPiercing />} />
        <Route path="/snakebitemidipiercing" element={<SnakeBiteMidiPiercing />} />
        <Route path="/conchpiercing" element={<ConchPiercing />} />
        <Route path="/contraconchpiercing" element={<ContraConchPiercing />} />
        <Route path="/orbitalpiercing" element={<OrbitalPiercing />} />
        <Route path="/snugpiercing" element={<SnugPiercing />} />
        <Route path="/surfacetraguspiercing" element={<SurfaceTragusPiercing />} />
        <Route path="/antitraguspiercing" element={<AntiTragusPiercing />} />
        <Route path="/lippiercing" element={<LipPiercing />} />
        <Route path="/lipsnakebitepiercing" element={<LipSnakeBitePiercing />} />
        <Route path="/ashleypiercing" element={<AshleyPiercing />} />
        <Route path="/medusalippiercing" element={<MedusaLipPiercing />} />
        <Route path="/monroelippiercing" element={<MonroeLipPiercing />} />
        <Route path="/verticallabretlippiercing" element={<VerticalLabretLipPiercing />} />
        <Route path="/cheekdimplepiercing" element={<CheekDimplePiercing />} />
        <Route path="/nipplepiercing" element={<NipplePiercing />} />
        <Route path="/intimatepiercing" element={<IntimatePiercing />} />
        <Route path="/chestdermalpiercing" element={<ChestDermalPiercing />} />
        <Route path="/chestsurfacepiercing" element={<ChestSurfacePiercing />} />
        <Route path="/fingerdermalpiercing" element={<FingerDermalPiercing />} />
        <Route path="/facedermalpiercing" element={<FaceDermalPiercing />} />
        <Route path="/handwristdermalpiercing" element={<HandWristDermalPiercing />} />
        <Route path="/backdimpledermalpiercing" element={<BackDimpleDermalPiercing />} />
        <Route path="/napepiercing" element={<NapePiercing />} />
        <Route path="/collarbonepiercing" element={<CollarBonePiercing />} />
        <Route path="/microdermalpiercing" element={<MicroDermalPiercing />} />
        <Route path="/snakeeyetonguepiercing" element={<SnakeEyeTonguePiercing />} />
        <Route path="/tonguewebpiercing" element={<TongueWebPiercing />} />


        <Route path="/success" element={<SuccessPage />} />

        {/* Admin Pages (no Header) */}
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />

        {/* 404 Page */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </div>
  );
};

const App = () => (
  <Router>
    <AppContent />
  </Router>
);

export default App;
